import { TravelArea } from '@modules/ticket-fares-store/client/src';
import { TicketSelectorPanelProps } from '@modules/ticket-search/components/ticket-accordion-panel/ticketSelectorPanelProps.interface';
import { RadioGroupProps } from '@nx-ng/types';
import { determineFareSelectorRadioOptions } from './format-option-common';

export const TRAVEL_ZONE_LOOKUP: RadioGroupProps<string> = {
  groupName: 'zone',
  standard: [
    {
      titleKey: 'travel_zone_west_midlands',
      value: '1',
      action: {
        actionLabelKey: 'see_map',
        modalType: 'map',
      },
    },
    {
      titleKey: 'travel_zone_west_midlands_and_metro',
      value: '2',
      action: {
        actionLabelKey: 'see_map',
        modalType: 'map',
      },
    },
    {
      titleKey: 'travel_zone_coventry',
      value: '4',
      action: {
        actionLabelKey: 'see_map',
        modalType: 'map',
      },
    },

    {
      titleKey: 'travel_zone_sandwell_and_dudley',
      value: '11',
      action: {
        actionLabelKey: 'see_map',
        modalType: 'map',
      },
    },

    {
      titleKey: 'travel_zone_walsall',
      value: '12',
      action: {
        actionLabelKey: 'see_map',
        modalType: 'map',
      },
    },
  ],
};

export const buildTravelZoneOptions = (
  zones: TravelArea[] = [],
  selectedZone: string | undefined
): TicketSelectorPanelProps => {
  const zoneIds =
    zones?.map((travelArea: TravelArea) => travelArea.id || '') || [];

  const items: RadioGroupProps<string> = determineFareSelectorRadioOptions({
    allOptions: TRAVEL_ZONE_LOOKUP,
    validIds: zoneIds,
    selectedValue: selectedZone,
  });

  return {
    category: 'zone',
    selectKey: 'label_select_zone',
    radio: items,
  };
};
